import { api } from "./api";

export const stripeCheckoutApi = (params) => {
    return api.post(`/payment/stripe/checkout`, JSON.stringify(params));
};

export const stripePaymentSuccessApi = (params) => {
    return api.post(`/payment/stripe/verify-payment`, JSON.stringify(params));
};

export const plansListApi = (params) => {
    return api.get(`/subscription/plans`, { params });
};

export const subscriptionListApi = (params) => {
    return api.get(`/subscription/list`, { params });
};

export const razorpayCreateOrderApi = (params) => {
    return api.post(`/payment/razorpay/create-order`, JSON.stringify(params));
};

export const razorpayPaymentSuccessApi = (params) => {
    return api.post(`/payment/razorpay/verify-payment`, JSON.stringify(params));
};